<script setup>
  import { ref, computed, watchEffect} from 'vue';
  import Icon from './icons/Icon.vue';
  import { format } from "date-fns";

  const props = defineProps({
    value: {
      type: Number,
      required: true
    },
    iconName: {
      type: String,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    graph: {
      type: [Object, null],
      required: true
    }
  });

  const markerPosition = ref({ x: 0, y: 0 });
  const graph = ref(props.graph)

  const labelStyle = computed(() => {
    return {
      position: 'absolute',
      left: `${markerPosition.value.x + props.graph.plotLeft}px`,
      top: `${props.graph.plotTop + props.graph.plotHeight}px`,
    };
  });

  watchEffect(() => {
    if (props.position) {
      markerPosition.value = props.position;
    }
  });
</script>

<template>
  <Teleport :to="graph.container">
    <div
      class="jwx-tide-graph__solunar-marker"
      :data-type="props.iconName"
      :style="labelStyle"
    >
      <Icon :name="props.iconName" class="jwx-tide-graph__solunar-marker-icon" />
    </div>
  </Teleport>
</template>